import { AppAccessDenied } from "components";
import useAppPermission from "hooks/useAppPermission";
import useUrl from "hooks/useUrl";
import { FC, Fragment, ReactNode } from "react";
import { PermissionType } from "utils/constants/permissions";

interface WrapperProps {
    permissionCode: PermissionType;
    children: ReactNode;
}
const Wrapper: FC<WrapperProps> = ({ permissionCode, children }) => {
    const { allow } = useAppPermission();
    const { url } = useUrl();
    if (!allow(permissionCode)) {
        return <AppAccessDenied homeUrl={url("URL_DASHBOARD")} />
    }
    return <Fragment>{children}</Fragment>
}
export default Wrapper;